import React from "react";
import MainLayout from "./MainLayout";
import Logout from "../common/auth/Logout";

const LogoutPage = (props) => <MainLayout component={Logout} otherProps={props} />;

export default LogoutPage;
